<template>
  <div>
    <span style="margin-right: 3px;">时间</span>
    <el-date-picker @change="val => $emit('change', val)"
                    v-model="chooseTime" :type="type"
                    size="small" value-format="yyyy-MM"
                    :format="typeMapping[type].format"
                    :placeholder="`选择${typeMapping[type].label}`">
    </el-date-picker>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'date-picker-box',
    props: {
      type: {
        type: String,
        validator (val) {
          return ['month', 'year'].includes(val)
        }
      }
    },
    data () {
      return {
        chooseTime: '',
        typeMapping: {
          month: {
            label: '月',
          },
          year: {
            label: '年',
            format: 'yyyy 年'
          }
        }
      }
    },
    mounted () {
      Vue.nextTick(() => {
        this.$emit('change', this.chooseTime)
      })
    }
  }
</script>

<style lang="less">
  .big-date-picker.el-date-editor {
    width: 320px;
    height: 80px;

    .el-input__inner {
      height: 80px;
      padding-left: 110px;
      font-size: 20px;
    }
    .el-input__prefix {
      left: auto;
      right: 105px;
      height: 78px;
      font-size: 18px;
    }
    .el-input__suffix {
      height: 77px;
      right: 64px;
      font-size: 20px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicControl/electronic-record/date-picker-box.vue